<script>
    import Card from '@/components/Card'

    export default {
        components: {
            Card,
        },

        mounted() {
            this.$root.restrictCountries('*')
            this.$store.commit('mainPage', {
                current: this.$t('Sub-brands'),
                stack: [{
                    'path': '/sub-brands',
                    'title': this.$t('Sub-brands'),
                }]
            })
        },
    }
</script>

<template>
    <section class="section">
        <div class="container-fluid">
            <card class="is-card-table has-pagination has-bottom-left-hidden">
                <bg-table-groups :label="$t('Sub-brands')"/>
            </card>
        </div>
    </section>
</template>
